import React, { useState } from "react";
import { TemplateForm } from "./template-form";
import { BroadcastAppCard, Container, ContainerActions } from "../styles";
import { SelectTagWidgetContainer } from "../../BroadcastView.styles";
import {
  BackLink,
  WizardCard,
  WizardCardDescription,
  WizardCardTitle,
} from "../../Campaigns.style";
import { TemplateSelectForm } from "./template-select-form";
import Button from "../../../../../components/shared/components/button/Button.style";

const steps = {
  TEMPLATE_CREATE: "TEMPLATE_CREATE",
  TEMPLATE_SELECT: "TEMPLATE_SELECT",
};

export const TemplateStep = ({
  handleNext,
  handleBack,
  updateBroadcastData,
  broadcastData,
  handleSkip,
}) => {
  const [step, setStep] = useState(null);

  const handleOnBack = () => {
    setStep(null);
  };

  return (
    <>
      {step === null && (
        <SelectTagWidgetContainer>
          <BroadcastAppCard>
            <Container>
              <WizardCard onClick={() => setStep(steps.TEMPLATE_CREATE)}>
                <WizardCardTitle>Crear plantilla</WizardCardTitle>

                <WizardCardDescription>
                  Crea una plantilla de WhatsApp para enviar a tus contactos.
                </WizardCardDescription>

                <Button designV4 style={{ width: "100%", marginTop: "auto" }}>
                  Crear
                </Button>
              </WizardCard>

              <WizardCard onClick={() => setStep(steps.TEMPLATE_SELECT)}>
                <WizardCardTitle>Seleccionar plantilla</WizardCardTitle>

                <WizardCardDescription>
                  Selecciona una plantilla de WhatsApp para enviar a tus
                  contactos.
                </WizardCardDescription>

                <Button designV4 style={{ width: "100%", marginTop: "auto" }}>
                  Seleccionar
                </Button>
              </WizardCard>
            </Container>

            <ContainerActions>
              <BackLink onClick={handleBack}>← Atrás</BackLink>
            </ContainerActions>
          </BroadcastAppCard>
        </SelectTagWidgetContainer>
      )}

      {step === steps.TEMPLATE_CREATE && (
        <TemplateForm
          handleNext={handleNext}
          handleBack={handleOnBack}
          updateBroadcastData={updateBroadcastData}
          broadcastData={broadcastData}
          handleSkip={handleSkip}
        />
      )}

      {step === steps.TEMPLATE_SELECT && (
        <TemplateSelectForm
          handleNext={handleNext}
          handleBack={handleOnBack}
          updateBroadcastData={updateBroadcastData}
          broadcastData={broadcastData}
          handleSkip={handleSkip}
        />
      )}
    </>
  );
};
